import {useEffect, useState} from 'react';
import {useMutation} from 'react-query';
import {useDispatch, useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {RootState} from '../../../..';
import CustomisedCardLine from '../../../../components/card/cardLine';
import LoanDetailComponent from '../../../../components/loanDetail/loanDetailComponent';
import {useAuth} from '../../../../config/AuthProvider/authProvider';
import {
    IFileResponse,
    ILoanDetailResponse,
} from '../../../../models/loan.model';
import {
    changeRouteType,
    getNextInnerState,
} from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import {setHeaderTitle} from '../../../../redux/headerTitle/headerTitleSlice';
import {getpervStateTab} from '../../../../redux/loansTab/loansTabSlice';
import {CancelLoan, GetLoanDetail} from '../../../../services/loan.service';
import FullScreenMultiImage from '../attachedImage/fullScreenMultiImage';
import {IMultiImage} from '../attachedImage/IMultiImage';
import AdditionalInformationTab from './additionalInformation/additionalInformationTab';
import Contract from './contract/contract';
import AttachedFile from './guarantee/attachedFile';
import GuaranteeTab from './guarantee/guaranteeTab';
import LoanDetailSkeleton from './loanDetailSkeleton';
import {TInnerStateLoanDetail} from './TInnerStateLoanDetail';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import TextCard from '../../../../components/card/TextCard';
import InfoIcon from '@mui/icons-material/Info';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import BusinessIcon from '@mui/icons-material/Business';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import GppGoodIcon from '@mui/icons-material/GppGood';
import MailBox from '../../../../components/icons/MailBox';
import Payment from '../../../../components/icons/Payment';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import {Navigate, Route, Routes, useNavigate} from 'react-router-dom';

export default function LoanDetail() {
    const navigate = useNavigate();
    //const stateFromRedux = useSelector((state: RootState) => state.prevAndNextState.nextInnerState) as TInnerStateLoanDetail;
    const stateFromRedux = useSelector(
        (state: RootState) => state.prevAndNextState.nextInnerState
    ) as TInnerStateLoanDetail;

    const {referenceKey} = useAuth();
    const [canCancel, setCanCancel] = useState<boolean>(true);
    const [canContinue, setCanContinue] = useState<boolean>(true);
    const [gaurantorsAttachedFiles, setGaurantorsAttachedFiles] =
        useState<IMultiImage[]>();
    const [additionalAttachedFiles, setAditionalAttachedFiles] =
        useState<IMultiImage[]>();
    const [fullScreenFiles, setFullScreenFiles] = useState<IFileResponse[]>();

    const [finalTabs, setFinalTabas] = useState<any>();
    const [showTabs, setShowTabas] = useState<boolean>(false);
    const [showAditionalAttachedFiles, setShowAditionalAttachedFiles] =
        useState<boolean>(false);
    const [selectedTab, setSelectedTab] = useState<number | undefined>(
        undefined
    );

    const handleAttachedImage = (tabIndex: number) => {
        //setInnerState('loanDetailAttachedFile')
        setShowAditionalAttachedFiles(false);
        navigate('/loans/detail/attachments');

        setSelectedTab(tabIndex);
    };

    const handleAditionalAttachedImage = (tabIndex: number) => {
        setShowAditionalAttachedFiles(true);
        navigate('/loans/detail/attachments');

        setSelectedTab(tabIndex);
    };

    const cancelLoanMutation = useMutation(CancelLoan, {
        onSuccess: (data: boolean) => {
            if (data == true) {
                toast.success('حذف تسهیلات با موفقیت انجام شد.');
                // dispatch(changeRouteType({ routeType: 'loans' }));
                navigate('/loans');
            }
        },
    });

    let count = 0;
    const {mutate: getLoanDetailMutation, isLoading} = useMutation(
        GetLoanDetail,
        {
            onSuccess: (data: ILoanDetailResponse) => {
                if (data != null) {
                    let tabs: any[] = [];
                    setCanCancel(data.canCancel);
                    setCanContinue(data.canContinue);
                    const installmentTemp = [
                        {
                            title: (
                                <>
                                    <Payment
                                        sx={{
                                            marginLeft: '5px',
                                            fontSize: '20px',
                                            marginBottom: '5px',
                                        }}
                                    />
                                    مبلغ تسهیلات (ریال)
                                </>
                            ),
                            value: (
                                <span className="text-sm text-[var(--tirnary-text-color)]">
                                    {data.loanAmount.toLocaleString('fa')}
                                </span>
                            ),
                        },
                        {
                            title: (
                                <>
                                    <InfoIcon
                                        sx={{
                                            marginLeft: '5px',
                                            fontSize: '20px',
                                        }}
                                    />
                                    وضعیت تسهیلات
                                </>
                            ),
                            value: (
                                <span
                                    className="text-sm text-[var(--tirnary-text-color)]"
                                    style={{
                                        color:
                                            data?.loanRequestStatusId ===
                                            'CanceledBySetad'
                                                ? '#FF617C'
                                                : '',
                                    }}
                                >
                                    {data?.loanRequestStatusTitle}
                                </span>
                            ),
                        },
                        {
                            title: (
                                <>
                                    <AccountBalanceIcon
                                        sx={{
                                            marginLeft: '5px',
                                            fontSize: '20px',
                                        }}
                                    />{' '}
                                    منبع تامین مالی
                                </>
                            ),
                            value: (
                                <div
                                    className="text-sm"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'end',
                                        color: 'var(--primary-text-color)',
                                    }}
                                >
                                    <span
                                        style={{
                                            float: 'right',
                                            fontSize: '0.9rem',
                                            color: 'var(--tirnary-text-color)',
                                            alignSelf: 'center',
                                            marginRight: '5px',
                                        }}
                                    >
                                        {data.financialSupplierTitle}
                                    </span>
                                </div>
                            ),
                        },
                        {
                            title: data.organizationInfo?.title ? (
                                <>
                                    <CorporateFareOutlinedIcon
                                        sx={{
                                            marginLeft: '5px',
                                            fontSize: '20px',
                                        }}
                                    />
                                    سازمان
                                </>
                            ) : (
                                ''
                            ),
                            value: data.organizationInfo?.title ? (
                                <div
                                    className="text-sm"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'end',
                                        color: 'var(--primary-text-color)',
                                    }}
                                >
                                    <span
                                        style={{
                                            float: 'right',
                                            fontSize: '0.9rem',
                                            color: 'var(--tirnary-text-color)',
                                            alignSelf: 'center',
                                            marginRight: '5px',
                                        }}
                                    >
                                        {data?.organizationInfo?.title}
                                    </span>
                                </div>
                            ) : (
                                ''
                            ),
                        },
                        {
                            title: '',
                            value: (
                                <TextCard
                                    title="شرایط تسهیلات"
                                    description={[
                                        {
                                            firstColumnText: 'تعداد اقساط',
                                            secondColumnText:
                                                data.installmentsQuantity +
                                                ' ماه',
                                        },
                                        {
                                            firstColumnText:
                                                '  فاصله بین اقساط',
                                            secondColumnText:
                                                data.loanStepSpace + ' ماه',
                                        },
                                        {
                                            firstColumnText: 'زمان بازپرداخت',
                                            secondColumnText:
                                                data.installmentDuration +
                                                ' ماه',
                                        },
                                        {
                                            firstColumnText: 'تاریخ درخواست',
                                            secondColumnText: data.creationDate,
                                        },
                                    ]}
                                />
                            ),
                        },
                        {
                            title: '',
                            value: (
                                <TextCard
                                    title="شرایط بازپرداخت"
                                    description={[
                                        {
                                            firstColumnText:
                                                'مبلغ هر قسط (ریال)',
                                            secondColumnText:
                                                data.installmentAmount.toLocaleString(
                                                    'fa'
                                                ),
                                        },

                                        {
                                            firstColumnText: 'نوع بازپرداخت',
                                            secondColumnText:
                                                data.repaymentTypeTitle,
                                        },
                                    ]}
                                />
                            ),
                        },
                    ];
                    tabs.push({
                        id: count,
                        title: 'تسهیلات',
                        child: (
                            <CustomisedCardLine itemList={installmentTemp} />
                        ),
                    });
                    count++;
                    let residentialTemp;
                    if (
                        data.residentialInformation.postalCode ||
                        data.residentialInformation.phoneNumber ||
                        data.residentialInformation.address
                    ) {
                        residentialTemp = [
                            //TODO
                            {
                                title: (
                                    <>
                                        <MailBox
                                            sx={{
                                                marginLeft: '5px',
                                                fontSize: '20px',
                                                marginBottom: '5px',
                                            }}
                                        />{' '}
                                        کد پستی محل سکونت
                                    </>
                                ),
                                value: data.residentialInformation.postalCode,
                            },
                            {
                                title: (
                                    <>
                                        <LocalPhoneIcon
                                            sx={{
                                                marginLeft: '5px',
                                                fontSize: '20px',
                                            }}
                                        />
                                        تلفن ثابت
                                    </>
                                ),
                                value: data.residentialInformation.phoneNumber,
                            },
                            {
                                value: data.residentialInformation.address,
                            },
                        ];
                    }
                    let jobInformationTemp;
                    if (
                        data.jobInformation.jobTitle ||
                        data.jobInformation.jobOrganization ||
                        data.jobInformation.creditScore ||
                        data.jobInformation.jobAddress
                    ) {
                        jobInformationTemp = [
                            //TODO
                            {
                                title: (
                                    <>
                                        <HomeRepairServiceIcon
                                            sx={{
                                                marginLeft: '5px',
                                                fontSize: '20px',
                                            }}
                                        />
                                        عنوان شغل
                                    </>
                                ),
                                value: data.jobInformation.jobTitle,
                            },
                            {
                                title: (
                                    <>
                                        <BusinessIcon
                                            sx={{
                                                marginLeft: '5px',
                                                fontSize: '20px',
                                            }}
                                        />
                                        نام سازمان
                                    </>
                                ),
                                value:
                                    data.organizationInfo != null
                                        ? data.organizationInfo.title
                                        : data.jobInformation.jobOrganization,
                            },
                            {
                                title: (
                                    <>
                                        <AttachMoneyIcon
                                            sx={{
                                                marginLeft: '5px',
                                                fontSize: '20px',
                                            }}
                                        />
                                        میانگین درآمد(ریال)
                                    </>
                                ),
                                value: data.jobInformation.incomeAverage,
                            },
                            {
                                value: data.jobInformation.jobAddress,
                            },
                        ];
                    }

                    let showAditionalAttachemntFilesBtn = false;

                    if (
                        (residentialTemp && residentialTemp.length > 0) ||
                        (jobInformationTemp && jobInformationTemp.length > 0)
                    ) {
                        let additionalFilesTemp = [] as IMultiImage[];
                        if (
                            data.residentialInformation.files &&
                            data.residentialInformation.files.length > 0
                        ) {
                            const residentialFilesTemp = {
                                title: 'مدارک سکونتی',
                                data: data.residentialInformation.files,
                            } as IMultiImage;
                            additionalFilesTemp.push(residentialFilesTemp);
                            showAditionalAttachemntFilesBtn = true;
                        }
                        if (
                            data.jobInformation.files &&
                            data.jobInformation.files.length > 0
                        ) {
                            const jobInfoFilesTemp = {
                                title: 'مدارک شغلی',
                                data: data.jobInformation.files,
                            } as IMultiImage;
                            additionalFilesTemp.push(jobInfoFilesTemp);
                            showAditionalAttachemntFilesBtn = true;
                        }
                        if (additionalFilesTemp.length > 0) {
                            setAditionalAttachedFiles(additionalFilesTemp);
                        }
                        tabs?.push({
                            id: count,
                            title: 'اطلاعات تکمیلی',
                            child: (
                                <AdditionalInformationTab
                                    tabIndex={count}
                                    residentialInformation={residentialTemp}
                                    jobInformation={jobInformationTemp}
                                    handleAttachedImage={
                                        handleAditionalAttachedImage
                                    }
                                    showAttachedFileButton={
                                        showAditionalAttachemntFilesBtn
                                    }
                                    additionalFields={data?.additionalFields!}
                                ></AdditionalInformationTab>
                            ),
                            // handleAttachedImage={handleAttachedImage} showAttachedFileButton={showGauratorsAttachemntFilesBtn}
                        });
                        count++;
                    }

                    let showGauratorsAttachemntFilesBtn = false;
                    const userGaurantorTemp = [
                        //TODO
                        {
                            title: (
                                <>
                                    <GppGoodIcon
                                        sx={{
                                            marginLeft: '5px',
                                            fontSize: '20px',
                                        }}
                                    />
                                    نوع ضمانت
                                </>
                            ),
                            value: data.guarantee.guaranteeTypeTitle,
                        },
                    ];
                    if (
                        data.guarantee.totalAmount != 0 &&
                        data.guarantee.totalAmount
                    ) {
                        userGaurantorTemp.push({
                            title: (
                                <>
                                    <AttachMoneyIcon
                                        sx={{
                                            marginLeft: '5px',
                                            fontSize: '20px',
                                        }}
                                    />
                                    مبلغ ضمانت (ریال)
                                </>
                            ),
                            value: data.guarantee.totalAmount.toLocaleString(),
                        });
                    }

                    if (data.guarantee) {
                        let tempFiles = [] as IMultiImage[];
                        if (
                            data.guarantee.files &&
                            data.guarantee.files.length > 0
                        ) {
                            var userGuarantorTemp = {
                                title: 'مدارک ضامنتی شما',
                                data: data.guarantee.files,
                            } as IMultiImage;
                            tempFiles.push(userGuarantorTemp);
                            showGauratorsAttachemntFilesBtn = true;
                        }
                        data.guarantee.guarantors.forEach((element) => {
                            if (element.files && element.files.length > 0) {
                                var temp = {
                                    data: element.files,
                                    title: 'ضامن ( ' + element.fullName + ')',
                                } as IMultiImage;
                                tempFiles.push(temp);
                                showGauratorsAttachemntFilesBtn = true;
                            }
                        });

                        if (tempFiles.length > 0) {
                            setGaurantorsAttachedFiles(tempFiles);
                        }

                        if (
                            data.guarantee.guaranteeTypeTitle ||
                            data.guarantee.totalAmount ||
                            (data.guarantee.guarantors &&
                                data.guarantee.guarantors.length > 0)
                        ) {
                            tabs.push({
                                id: count,
                                title: 'ضمانتی',
                                child: (
                                    <GuaranteeTab
                                        tabIndex={count}
                                        guarantors={data.guarantee.guarantors}
                                        userInfo={userGaurantorTemp}
                                        handleAttachedImage={
                                            handleAttachedImage
                                        }
                                        showAttachedFileButton={
                                            showGauratorsAttachemntFilesBtn
                                        }
                                    ></GuaranteeTab>
                                ),
                            });
                            count++;
                        }
                    }

                    if (
                        data.contractInformation &&
                        (data.contractInformation?.internal ||
                            data.contractInformation?.bankContract)
                    ) {
                        tabs.push({
                            id: count,
                            title: 'قراردادها',
                            child: (
                                <Contract
                                    internal={
                                        data.contractInformation?.internal
                                    }
                                    bankContract={
                                        data.contractInformation?.bankContract
                                    }
                                ></Contract>
                            ),
                        });
                        count++;
                    }

                    setFinalTabas(tabs);

                    setShowTabas(true);
                }
            },
            onError: () => {},
        }
    );

    const dispatch = useDispatch();

    useEffect(() => {
        getLoanDetailMutation({referenceKey: referenceKey!});

        // dispatch(changeRouteType({ routeType: 'loanDetail' }));
        // dispatch(
        //     setHeaderTitle({
        //         color: "#fff",
        //         header: 'جزییات تسهیلات',
        //         parentRoute: 'loans',
        //     })
        // );
    }, []);

    const handleCancel = () => {
        cancelLoanMutation.mutate({referenceKey: referenceKey!});
    };
    const handleContinue = () => {
        navigate('/loans/request');
    };
    const showFullAttachments = (data: IFileResponse[]) => {
        setFullScreenFiles(data);
        navigate('/loans/detail/attachments/fullscreen');
    };

    useEffect(() => {
            dispatch(
                setHeaderTitle({
                    color: 'var(--header-color)',
                    header: 'جزییات تسهیلات',
                    parentRoute: 'loans',
                })
            );
            dispatch(changeRouteType({routeType: 'loans'}));
    }, []);
    const details = <LoanDetailComponent
                setSelectedTab={setSelectedTab}
                selectedTab={selectedTab}
                canCancel={canCancel}
                canContinue={canContinue}
                handleCancel={handleCancel}
                handleContinue={handleContinue}
                tabs={finalTabs}
            ></LoanDetailComponent>;
    const attachments = <AttachedFile
                images={
                    showAditionalAttachedFiles
                        ? additionalAttachedFiles
                        : gaurantorsAttachedFiles
                }
                showFullAttachments={showFullAttachments}
            ></AttachedFile>;

    if (!showTabs) {
        return <LoanDetailSkeleton />;
    } else {
        return <div className="px-5"><Routes>
            <Route index element={details} />
            <Route path="attachments" element={attachments} />
            <Route path="attachments/fullscreen" element={<FullScreenMultiImage data={fullScreenFiles} />} />
            <Route path="*" element={<Navigate to="/loans/detail" replace />} />
        </Routes></div>;
    }
}
